import { useFinanceEntries } from "web_myplann/Finances/Hooks/useFinanceEntries";

export const useFinancialBalance = () => {
	const {
		incomeEntries,
		expenseEntries,
		totalIncome,
		totalExpenses,
		hasIncomeData,
		hasExpenseData,
		isLoading,
	} = useFinanceEntries();

	return {
		isLoading,
		hasNoData: !hasIncomeData && !hasExpenseData,
		hasNoBalance:
			hasIncomeData &&
			hasExpenseData &&
			incomeEntries.length === 0 &&
			expenseEntries.length === 0,
		incomeSum: totalIncome,
		expenseSum: totalExpenses,
		balance: totalIncome - totalExpenses,
	};
};
